import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  banner: {
    backgroundColor: theme.palette.primary.main,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '10px 40px 10px 16px',
    flexShrink: 0,
    position: 'relative',
    '@media (min-width:961px)': {
      marginLeft: 240,
      width: 'calc(100% - 240px)'
    },
    '@media (max-width:960px)': {
      width: '100%'
    }
  },
  text: {
    fontSize: 13,
    color: '#fff',
    fontFamily: 'Open Sans, sans-serif',
    textAlign: 'center',
    [theme.breakpoints.down('xs')]: {
      fontSize: 11
    }
  },
  link: {
    color: '#fff',
    fontWeight: 700,
    textDecoration: 'underline',
    '&:hover': {
      color: '#fff'
    }
  },
  closeButton: {
    position: 'absolute',
    right: 12,
    top: '50%',
    transform: 'translateY(-50%)',
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    padding: 4,
    color: '#fff',
    display: 'flex',
    alignItems: 'center',
    '&:hover': {
      opacity: 0.7
    },
    '& svg': {
      fontSize: 18
    }
  }
}))
